import { Card, CardBody, Col, ListGroup, ListGroupItem } from "reactstrap";
import { Badges } from "../../../../AbstractElements";
import { NumberedBadgeListTitle } from "../../../../Constants/Constants";
import { BadgeListData, NumBadgeListSubTitle } from "../../../../Data/UiKits/Lists";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const NumberedBadgeList = () => {
  return (
    <Col xxl="4" md="6">
      <Card>
        <CommonCardHeader title={NumberedBadgeListTitle} span={NumBadgeListSubTitle} />
        <CardBody>
          <ListGroup numbered className="badge-list">
            {BadgeListData &&
              BadgeListData.map((item, index) => (
                <ListGroupItem key={index}>
                  <div>{item.text}</div>
                  <Badges color={item.badgeClass} className="p-2" pill>
                    {item.badgeText}
                  </Badges>
                </ListGroupItem>
              ))}
          </ListGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
export default NumberedBadgeList